import { createSlice } from "@reduxjs/toolkit";
import {
  GET_MYDIARY_DEALER_DETAILS_SUCCESS,
  GET_MYDIARY_DEALER_DETAILS_FAIL,
  GET_MYDIARY_WSS_DETAILS_SUCCESS,
  GET_MYDIARY_WSS_DETAILS_FAIL,
} from "../constants/action-types";

// Matches original initialVisitDetailsState used by this reducer
const diarySlice = createSlice({
  name: "myDiary",
  initialState: { checkInDetails: [], checkInWSSDetails: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_MYDIARY_DEALER_DETAILS_SUCCESS, (state, { payload }) => {
        state.mydiaryDealerDetails = payload;
      })
      .addCase(GET_MYDIARY_DEALER_DETAILS_FAIL, (state) => {
        state.mydiaryDealerDetails = "";
      })
      .addCase(GET_MYDIARY_WSS_DETAILS_SUCCESS, (state, { payload }) => {
        state.mydiaryWSSDetails = payload;
      })
      .addCase(GET_MYDIARY_WSS_DETAILS_FAIL, (state) => {
        state.mydiaryWSSDetails = "";
      });
  },
});

export const getMyDiaryDetailsReducer = diarySlice.reducer;
